export default __webpack_public_path__ + "static/media/card_talhao.94d96761.svg";